import { useMutation, useQueryClient } from "@tanstack/react-query";

import { type UpdateDocumentInput, updateDocument } from "@/adapters/api";
import { toDocument } from "../utils/map.ts";
import { documentsQueryKey } from "./use-documents.ts";

export function useUpdateDocument(constructionId: string | undefined) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async ({
			documentId,
			input,
		}: {
			documentId: string;
			input: UpdateDocumentInput;
		}) => {
			if (!constructionId) throw new Error("missing construction");
			return toDocument(
				await updateDocument(constructionId, documentId, input),
			);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: documentsQueryKey(constructionId),
			});
		},
	});
}
